import { Checkbox, Grid } from "@material-ui/core";
import { memo } from "react";
import { CategoryLoading } from "../styles/loading";

const LoadingCheckBox = () => (
  <Grid container direction="row" alignItems="center">
    <Grid item>
      <Checkbox disabled checked={false} />
    </Grid>
    <Grid item xs>
      <CategoryLoading />
    </Grid>
  </Grid>
);

export default memo(LoadingCheckBox);
